import getBadges from 'helpers/badge'
import { PRODUCT_TYPES } from 'helpers/constants'
import { formatMoney } from 'libs/shopify'
import clsx from 'clsx'
import { handleize } from 'helpers/utils'
import Image from 'snippets/image/image'

function ProductBadges({ product, currentVariant, max = 2, classBadges = 'left-3 top-[14px] lg:left-5 lg:top-5' }) {
  const data = product || window.productState?.initProduct
  const { bundleBadgeLabel } = GM_STATE.customs

  if (!data) return null

  const compareAtPrice = data.compare_at_price ?? data.compareAtPrice ?? currentVariant?.compare_at_price ?? '0.00'
  const price = Number(data.price ?? currentVariant?.price ?? 0)
  let productBadges = getBadges(data, currentVariant, max)

  if (data.type === PRODUCT_TYPES.VALUE_BUNDLE && compareAtPrice && compareAtPrice > price) {
    const newBadge = {
      type: 'custom',
      label: `${bundleBadgeLabel} ${formatMoney(compareAtPrice.toString())}`
    }

    productBadges = productBadges?.length > 1 ? [newBadge, ...productBadges.slice(0, 1)] : [newBadge, ...productBadges]
  }

  if (data.tags.includes('badge:bonus product')) {
    productBadges = [
      {
        type: 'custom',
        label: 'bonus product'
      }
    ]
  }

  if (!productBadges?.length && !data.metafields?.custom_award_badge) return null

  if (data.metafields?.custom_award_badge)
    return (
      <div className={`pointer-events-none absolute z-2 flex flex-col gap-2 lg:gap-2.5 ${classBadges}`}>
        <Image
          url={data.metafields.custom_award_badge}
          className="aspect-square w-16 overflow-hidden lg:w-[86px]"
          imageClass="w-full h-full"
          alt="Award"
          width={86}
          height={86}
          isCover
        />
      </div>
    )

  return (
    <div
      className={`product-badges pointer-events-none absolute z-2 flex flex-col gap-2 lg:gap-2.5 ${classBadges}`}
    >
      {productBadges.map((badge, index) => {
        const label = badge.label?.toLowerCase()
        const isAlchemyBadge = label?.includes('alchemy')
        const badgeLabel = label ? handleize(label) : ''

        return (
          <div
            key={badge.label || index}
            className={clsx(
              'badge font-inter',
              isAlchemyBadge ? 'bg-[#aeb7a7] text-white' : '',
              badgeLabel && `badge__${badgeLabel}`
            )}
          >
            {badge.label}
          </div>
        )
      })}
    </div>
  )
}

export default ProductBadges
